
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.375 10.284V9.105s1.078-1.034 1.156-1.74c0 0 .563-.395.563-1.104 0-.492-.215-.566-.215-.566s.387-.748.387-1.462c0-1.432-.706-2.533-1.891-2.533 0 0-.503-.7-1.375-.7-1.85 0-3.352 1.135-3.352 3.167 0 .859.473 1.528.473 1.528s-.215.107-.215.566c0 .89.563 1.104.563 1.104.078.706 1.156 1.74 1.156 1.74v1.18C6.046 12.051 2.5 10.886 2.5 15h11c0-4.127-3.546-2.948-4.125-4.716z"}})])
          )
        }
      }
    